import SectionHeading from '@/components/feature/SectionHeading';
import { seriesZone } from '@/mocks/library';

export default function SeriesZone() {
  return (
    <section id="series" className="w-full bg-background-50 px-4 md:px-8 py-14 md:py-20 scroll-mt-20">
      <SectionHeading
        eyebrow="追更专区"
        title="全集与追更专区"
        description="每张卡片标出总集数与当前进度：进度等于总集数即为完结，可连续观看；未完结的会写明更新频率，方便安排追更节奏。"
      />

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {seriesZone.map((item) => {
          const done = item.latest >= item.episodes;
          const percent = Math.round((item.latest / item.episodes) * 100);
          return (
            <article
              key={item.id}
              className="rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 flex flex-col"
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-600">{item.note}</p>
                </div>
                <span
                  className={`shrink-0 text-[11px] px-2.5 py-1 rounded-full whitespace-nowrap ${
                    done ? 'bg-secondary-100 text-secondary-900' : 'bg-accent-100 text-accent-900'
                  }`}
                >
                  {done ? '已完结' : '更新中'}
                </span>
              </div>

              <div className="mt-5">
                <div className="flex items-end justify-between">
                  <span className="text-xs text-foreground-600">当前进度</span>
                  <span className="text-sm font-bold text-foreground-950">
                    {item.latest}
                    <span className="text-foreground-500 font-normal"> / {item.episodes} 集</span>
                  </span>
                </div>
                <div className="mt-2 h-2 rounded-full bg-background-300 overflow-hidden" role="presentation">
                  <div
                    className={`h-full rounded-full ${done ? 'bg-secondary-500' : 'bg-primary-500'}`}
                    style={{ width: `${percent}%` }}
                  ></div>
                </div>
              </div>

              <div className="mt-5 flex items-center gap-2 text-xs text-foreground-600">
                <i className="ri-hourglass-2-line text-primary-600" aria-hidden="true"></i>
                <span>
                  {done ? '所有集数已整理完毕' : `还剩 ${item.episodes - item.latest} 集待更新`}
                </span>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}